// extracted by mini-css-extract-plugin
export default {"form":"styles_form__KfjiI","tabs_style":"styles_tabs_style__YUNCl"};